/*
 * Instagram feed (sections/tcs-tagged-feed.liquid): the lightbox. The row of posts is a shelf, with its
 * arrows and progress line from assets/tcs-shelf.js.
 *
 * Lightbox: a post opens in the section's .tcs-overlay dialog, filled from the post's own <template>.
 * tcs.js opens and closes it (Esc, the backdrop, the animation, focus back to the post). Pictures swipe
 * or step with the arrows; the arrows beside the box, and ← → past the last picture, move between posts.
 * A click with a modifier key, or before tcs.js has loaded, just follows the link to Instagram.
 */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const behavior = () => (reduce.matches ? 'auto' : 'smooth');

  function initLightbox(root, track) {
    const dialog = root.querySelector('[data-tagged-lightbox]');
    if (!dialog) return;
    const $ = (sel) => dialog.querySelector(sel);
    const slides = $('[data-lb-slides]');
    const count = $('[data-lb-count]');
    const stepPrev = $('[data-lb-step="-1"]');
    const stepNext = $('[data-lb-step="1"]');
    const postPrev = $('[data-lb-post="-1"]');
    const postNext = $('[data-lb-post="1"]');
    const items = [...track.children];
    let current = -1;
    let frame = 0;

    const slideAt = () => (slides.clientWidth ? Math.round(slides.scrollLeft / slides.clientWidth) : 0);
    const updateSlides = () => {
      frame = 0;
      const total = slides.children.length;
      const at = slideAt();
      dialog.classList.toggle('has-slides', total > 1);
      count.textContent = total > 1 ? `${at + 1} / ${total}` : '';
      stepPrev.disabled = at <= 0;
      stepNext.disabled = at >= total - 1;
    };
    const goSlide = (dir) => slides.scrollBy({ left: dir * slides.clientWidth, behavior: behavior() });

    const show = (index) => {
      const item = items[index];
      const data = item?.querySelector('[data-tagged-detail]')?.content.firstElementChild;
      if (!data) return false;
      current = index;
      const pictures = [...data.querySelectorAll(':scope > li')].map((li) => li.cloneNode(true));
      pictures[0]?.querySelector('img')?.setAttribute('loading', 'eager');
      slides.replaceChildren(...pictures);
      slides.scrollLeft = 0;
      $('[data-lb-by]').textContent = data.dataset.by;
      $('[data-lb-caption]').textContent = data.querySelector('[data-caption]')?.textContent || '';
      $('[data-lb-date]').textContent = data.dataset.date;
      $('[data-lb-link]').href = data.dataset.link;
      $('.tcs-overlay__body').scrollTop = 0;
      postPrev.disabled = index <= 0;
      postNext.disabled = index >= items.length - 1;
      // Focus goes back to the post last shown, so keep it in view on the shelf behind.
      const link = item.querySelector('a');
      dialog.returnFocusTo = link;
      track.scrollTo({ left: item.offsetLeft - parseFloat(getComputedStyle(track).scrollPaddingInlineStart || 0), behavior: 'auto' });
      updateSlides();
      return true;
    };
    const goPost = (dir) => {
      const index = current + dir;
      if (index >= 0 && index < items.length) show(index);
    };

    track.addEventListener('click', (event) => {
      const link = event.target.closest('.tcs-tagged__post');
      if (!link || !window.tcs || event.defaultPrevented) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const index = items.indexOf(link.closest('.tcs-shelf__item'));
      if (!show(index)) return;
      event.preventDefault();
      window.tcs.open(dialog.id, link);   // tcs.open takes the dialog's id
      slides.focus({ preventScroll: true });
    });

    stepPrev.addEventListener('click', () => goSlide(-1));
    stepNext.addEventListener('click', () => goSlide(1));
    postPrev.addEventListener('click', () => goPost(-1));
    postNext.addEventListener('click', () => goPost(1));
    slides.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(updateSlides); }, { passive: true });

    // ← → go through the pictures, then on to the next or previous post.
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.target.closest('input, textarea')) return;
      event.preventDefault();
      const dir = event.key === 'ArrowRight' ? 1 : -1;
      const at = slideAt();
      if ((dir > 0 && at < slides.children.length - 1) || (dir < 0 && at > 0)) goSlide(dir);
      else goPost(dir);
    });

    // Let go of the pictures once it's closed.
    dialog.addEventListener('tcs:close', () => { slides.replaceChildren(); current = -1; });
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    initLightbox(root, root.querySelector('[data-shelf-track]'));
  }

  const boot = () => document.querySelectorAll('[data-tagged]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
